/**
 * IncomeRecorded.contract.ts — Event Contract System™ (generation v1).
 * DOMAIN INTEGRATION HARDENING sprint: a new income ledger entry was persisted
 * through the Career Domain Service (the only sanctioned write path).
 */

import type { EventContract } from '../EventContractRegistry';

export const IncomeRecordedContract: EventContract = {
  name: 'IncomeRecorded',
  version: 1,
  description: 'A new income entry was persisted via Career™ (API server is the persistence owner).',
  publishers: ['career-domain'],
  subscribers: ['income-page', 'companies-page', 'module:wallet'],
  fields: [
    { name: 'entryId', type: 'number', required: true, description: 'API-assigned income entry id' },
    { name: 'amount', type: 'number', required: true, description: 'Recorded amount (USD ledger)' },
    { name: 'source', type: 'string', required: true, description: 'Source / client label as entered' },
  ],
  allowExtraFields: true,
  timestampPolicy: 'Publish time (Date.now()) after the API create succeeds.',
  stability: 'stable',
  deprecated: false,
  example: { entryId: 42, amount: 125.5, source: 'Acme Corp' },
};
